import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { catchError, throwError } from 'rxjs';
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';
import { GroupService } from 'src/app/services/group.service';
import { AddNewGroupComponent } from '../add-new-group/add-new-group.component';

@Component({
    selector: 'app-update-group',
    templateUrl: './update-group.component.html',
    styleUrls: ['./update-group.component.css'],
    standalone: false
})
export class UpdateGroupComponent implements OnInit{


  updateGroupForm: FormGroup;

  groupId = this.data.groupId;
  group = this.data.group;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public cancelAddGroupDialog: MatDialogRef<AddNewGroupComponent>,
      private newGroupFb: FormBuilder,
      public addGroupDialog: MatDialogRef<AddNewGroupComponent>,
      private groupService: GroupService,
      public nav: NavBarComponent,
  ) {
    this.updateGroupForm = this.newGroupFb.group({
      groupName: new FormControl(''),
    });
  }
  ngOnInit(): void {
    if(this.data?.group?.isGrid){
      this.updateGroupForm.controls.groupName.setValue(this.data?.group?.name);
      return;
    }
     this.updateGroupForm.controls.groupName.setValue(this.data?.name);
  }



  updateGroup() {
    this.nav.toggleLoading(true);

      // let groupObj = {
      //   groupId: this.groupId,
      //   groupName: this.updateGroupForm.get('groupName').value,
      //   tenantId: Number(sessionStorage.getItem('selectedTenant'))
      // };

      console.log(this.group, 'this.group)');

let groupObj = {
            groupId: this.group?.id ?? this.groupId,
            name: this.updateGroupForm.get('groupName').value,
            isGrid: this.group?.isGrid ?? false,
            gridRotation: this.group?.gridRotation ?? 0,
            gridSpacing: this.group?.gridSpacing ?? 0,
            tenantId: Number(sessionStorage.getItem('selectedTenant')),
            userId: this.group?.user?.userId ?? null,
      };

      this.groupService.updateSampleGroups(
            groupObj.groupId,
            groupObj.name,
            groupObj.isGrid,
            groupObj.gridRotation,
            groupObj.gridSpacing,
            groupObj.tenantId,
            groupObj.userId,

      ).pipe(
          catchError(error => {
            console.error(error);
            return throwError(() => error);
          })
      ).subscribe(() => {
        this.close(groupObj.name);
        this.nav.toggleLoading(false);
      });
    // }
  }

  close(groupName?: string){
    this.cancelAddGroupDialog.close(groupName);
  }
}
